<template>
    <div class="lang">
        <div class="process">
            <div class="info on">
                <ul class="step-box">
                    <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Запись на прием</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Получение материалов и подтверждение записи на прием</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Регистрация в регистратуре</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 04</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Консультация у врача</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 05</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Оплата</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 06</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Обследование</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 07</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">Завершение обследования</h4>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="info">
                <h3 class="bullet01">Завершение обследования</h3>
                <p class="bullet03 depth">Тел. номер: 82-2-6986-2222~4</p>
                <p class="bullet03 depth">Собственнолично: справочный стол Оздоровительно-диагностического центра, 3 этаж, строение С, Клиника Женского университета Ивха в Сеуле</p>
                <p class="bullet03 depth">Онлайн: вы можете записаться на прием онлайн, нажав на кнопку ниже</p>
                <p class="bullet03 depth">Время для обращений: по будням с 9:00 ч. до 17:00 ч. (кроме субботы и выходных дней), вам перезвонит медсестра, как только будет окончательно определен срок обследования. При планировании обследования заранее
                    сообщите нам о принимаемых вами лекарственных средствах</p>
                <div class="botton-wrap"><a href="" class="main-button c-main">Запись на прием</a></div>
            </div>
            <div class="info">
                <h3 class="bullet01">Получение материалов и подтверждение записи на прием</h3>
                <p class="bullet03 depth">Предоставление информации об обследовании и получение расходного материала после определения даты обследования</p>
                <p class="bullet03 depth">Вам поступит телефонный звонок с подтверждением записи (счастливый звонок) за неделю до обследования</p>
                <p class="bullet03 depth">За день до обследования на ваш сотовый телефон поступит уведомляющее сообщение (SMS-сообщение).</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Анкета</h3>
                <p class="bullet03 depth">Проверьте направление на прием и зарегистрируйтесь в Справочном столе Оздоровительно-диагностического центра</p>
                <p class="bullet03 depth">Сдача материалов (анкеты, образцов кала, и т.д.)</p>
                <p class="bullet03 depth">Инструктаж о запланированных тестах и процедурах</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Беседа с врачом</h3>
                <p class="bullet03 depth">Консультация с врачом и заполнение формы информированного согласия перед началом медицинского обследования</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Оплата</h3>
                <p class="bullet03 depth">Оплата медицинского обследования</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Подготовка к обследованию</h3>
                <p class="bullet03 depth">Раздевание и облачение в медицинскую одежду и тапочки (удаление всех аксессуаров; драгоценности могут быть сложены отдельно)</p>
                <p class="bullet03 depth">Начало программы медицинского обследования (3–6 часов в зависимости от потребностей)</p>
            </div>
            <div class="info">
                <h3 class="bullet01">Обследование завершено</h3>
                <p class="bullet03 depth">Пациент информируется о мерах предосторожности, предпринимаемых дома (предоставляется ваучер на питание)</p>
                <p class="bullet03 depth">Планирование приема для ознакомления с результатами: выберите между личным визитом на консультацию и доставкой по почте</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>